import { useEffect, useState } from "react";
import { Loader, useFormValues } from "../../../shared";
import { SelectedMui } from "../../../shared/ui/selected/SelectedMui";
import { getRoleParams } from "../../../shared/service/role-translate";
import { Breadcrumbs } from "@/shared/ui/breadcrumbs/Breadcrumbs";
import { Button } from "@/shared/ui/button/Button";
import { CoursesModel, CreateUserSchema, userController, userStore } from "@/entities";
import { CardMain } from "@/widgets/info-card/info-card-main/CardMain";
import { Input } from "@/shared/ui/input/Input";
import { UserCoursesAddList } from "@/widgets/user/user-courses-add/UserCoursesAddList";

import styles from "./UserAdd.module.scss";

export const termValues: Record<string, number> = {
  "3 мес": 3,
  "6 мес": 6,
  год: 12,
};
export const term = ["3 мес", "6 мес", "год"];

const UserAdd = () => {
  const {
    changeInputs,
    errors,
    resetInput,
    setInitValues,
    validateValues,
    values,
  } = useFormValues({
    initValues: {
      username: "",
      email: "",
      role: "Пользователь",
      password: "",
      fio: "",
      organisation: "",
      position: "",
      phone: "",
      gender: "Мужской",
      duration: 0,
      price: "",
      course_id: 0,
    },
    payloadSchema: CreateUserSchema,
  });
  const [selectCourse, setSelectCourse] = useState<CoursesModel | null>(null);
  const [repeadPassword, setRepeadPassword] = useState<string>("");
  const [repeadPasswordError, setRepeadPasswordError] =
    useState<boolean>(false);

  const roles = userStore((state) => state.roles);
  const loading = userStore((state) => state.loading);
  const loadingSubmit = userStore((state) => state.loadingSubmit);

  const isValidRepeadPassword = (password: string): boolean => {
    if (password !== repeadPassword) {
      setRepeadPasswordError(true);
    }

    return password === repeadPassword;
  };

  const submit = () => {
    const payload = validateValues();

    if (!payload) return;

    if (!isValidRepeadPassword(payload.password)) return;

    const role = getRoleParams(values.role);
    payload.role = role;
    payload.gender = payload.gender === "Мужской" ? "male" : "female";

    //@ts-ignore
    payload.price = values.price ? Number(values.price) : 0;
    payload.duration = termValues[term[values.duration]];

    userController.createUser(payload).then((result) => {
      if (result === "success") {
        resetInput();
        setRepeadPassword("");
        setSelectCourse(null);
      }
    });
  };

  const handleChangeRepeadPassword = (value: string) => {
    setRepeadPassword(value);
    if (repeadPasswordError) {
      setRepeadPasswordError(false);
    }
  };

  const getRoles = async (): Promise<void> => {
    userController.getRoles();
  };

  useEffect(() => {
    if (roles.length) {
      setInitValues({ ...values, role: roles[0] });
    } else {
      setInitValues({ ...values, role: "Админ" });
    }
  }, [roles]);

  const fethInitData = async () => {
    await getRoles();
  };

  useEffect(() => {
    fethInitData();
  }, []);

  const breadcrumb = [
    { value: "Пользователи", href: "/users" },
    { value: "Создание пользователя", href: null },
  ];

  if (loading) {
    return <Loader />;
  }

  return (
    <>
      <Breadcrumbs breadcrumbs={breadcrumb} />
      <CardMain title="Создать нового пользователя">
        <section className={styles.form}>
          <div className={styles.inputLine}>
            {roles.length > 0 && (
              <SelectedMui
                label="Роль"
                menuList={roles}
                name="role"
                onChange={(e) => changeInputs(e.target.value, "role")}
                value={values.role ? values.role : ""}
              />
            )}
            <SelectedMui
              label="Пол"
              menuList={["Мужской", "Женский"]}
              name="gender"
              onChange={(e) => changeInputs(e.target.value, "gender")}
              value={values.gender ? values.gender : ""}
            />
          </div>
          <div className={styles.inputLine}>
            <Input
              name="username"
              error={errors.username}
              label="Логин *"
              onChange={changeInputs}
              value={values.username}
            />
            <Input
              name="email"
              error={errors.email}
              label="Электронная почта *"
              onChange={changeInputs}
              value={values.email}
            />
          </div>

          <Input
            name="fio"
            error={errors.fio}
            label="ФИО *"
            onChange={changeInputs}
            value={values.fio}
          />

          <div className={styles.inputLine}>
            <Input
              name="organisation"
              error={errors.organisation}
              label="Организация"
              onChange={changeInputs}
              value={values.organisation}
            />
            <Input
              name="position"
              error={errors.position}
              label="Должность"
              onChange={changeInputs}
              value={values.position}
            />
          </div>
          <Input
            name="phone"
            error={errors.phone}
            label="Контактный номер телефона"
            onChange={changeInputs}
            value={values.phone}
            type="number"
          />
          <div className={styles.inputLine}>
            <Input
              name="password"
              error={errors.password}
              label="Введите пароль *"
              onChange={changeInputs}
              value={values.password}
              type="password"
            />
            <Input
              name="repeadPassword"
              error={repeadPasswordError ? "Пароли должны совпадать" : ""}
              label="Повторите пароль *"
              onChange={handleChangeRepeadPassword}
              value={repeadPassword}
              type="password"
            />
          </div>
          <UserCoursesAddList
            selectCourse={selectCourse}
            handleselectCourse={(value) => setSelectCourse(value)}
            error={String(errors.course_id)}
            changeCourseId={(value) => changeInputs(value, "course_id")}
            price={String(values.price)}
            changePrice={(value) => changeInputs(value, "price")}
            term={term}
            valueTerm={term[values.duration]}
            changeTerm={(value) => changeInputs(value, "duration")}
          />
          <footer className={styles.submitButtons}>
            <div style={{ maxWidth: 200 }}>
              <Button
                text="Добавить пользователя"
                variant="contained"
                size="small"
                type="button"
                disabled={loadingSubmit}
                onClick={submit}
              />
            </div>
          </footer>
        </section>
      </CardMain>
    </>
  );
};

export default UserAdd;
